/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: Kb3kPKRcQbBm

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import MobileDrawerItemSubItem from "../../MobileDrawerItemSubItem"; // plasmic-import: 9A1EaT7k4Zaw/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicMobileDrawerItem.module.css"; // plasmic-import: Kb3kPKRcQbBm/css

createPlasmicElementProxy;

export type PlasmicMobileDrawerItem__VariantMembers = {
  active: "active";
  withAccordion: "withAccordion";
  expanded: "expanded";
};
export type PlasmicMobileDrawerItem__VariantsArgs = {
  active?: SingleBooleanChoiceArg<"active">;
  withAccordion?: SingleBooleanChoiceArg<"withAccordion">;
  expanded?: SingleBooleanChoiceArg<"expanded">;
};
type VariantPropType = keyof PlasmicMobileDrawerItem__VariantsArgs;
export const PlasmicMobileDrawerItem__VariantProps = new Array<VariantPropType>(
  "active",
  "withAccordion",
  "expanded"
);

export type PlasmicMobileDrawerItem__ArgsType = {
  item?: any;
  onContactClick?: () => void;
};
type ArgPropType = keyof PlasmicMobileDrawerItem__ArgsType;
export const PlasmicMobileDrawerItem__ArgProps = new Array<ArgPropType>(
  "item",
  "onContactClick"
);

export type PlasmicMobileDrawerItem__OverridesType = {
  drawerItem?: Flex__<"div">;
  itemWrapper?: Flex__<"a"> & Partial<LinkProps>;
  textWrapper?: Flex__<"div">;
  text?: Flex__<"div">;
  icon?: Flex__<"div">;
  arrowIcon?: Flex__<typeof PlasmicImg__>;
  submenu?: Flex__<"div">;
  mobileDrawerItemSubItem?: Flex__<typeof MobileDrawerItemSubItem>;
};

export interface DefaultMobileDrawerItemProps {
  item?: any;
  onContactClick?: () => void;
  active?: SingleBooleanChoiceArg<"active">;
  withAccordion?: SingleBooleanChoiceArg<"withAccordion">;
  expanded?: SingleBooleanChoiceArg<"expanded">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicMobileDrawerItem__RenderFunc(props: {
  variants: PlasmicMobileDrawerItem__VariantsArgs;
  args: PlasmicMobileDrawerItem__ArgsType;
  overrides: PlasmicMobileDrawerItem__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "active",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.active
      },
      {
        path: "withAccordion",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.withAccordion
      },
      {
        path: "expanded",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.expanded
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"drawerItem"}
      data-plasmic-override={overrides.drawerItem}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.drawerItem,
        {
          [sty.drawerItemactive]: hasVariant($state, "active", "active"),
          [sty.drawerItemexpanded]: hasVariant($state, "expanded", "expanded"),
          [sty.drawerItemwithAccordion]: hasVariant(
            $state,
            "withAccordion",
            "withAccordion"
          )
        }
      )}
    >
      <PlasmicLink__
        data-plasmic-name={"itemWrapper"}
        data-plasmic-override={overrides.itemWrapper}
        aria-label={(() => {
          try {
            return $props.item.name;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
        className={classNames(projectcss.all, projectcss.a, sty.itemWrapper, {
          [sty.itemWrapperexpanded]: hasVariant($state, "expanded", "expanded"),
          [sty.itemWrapperwithAccordion]: hasVariant(
            $state,
            "withAccordion",
            "withAccordion"
          )
        })}
        component={Link}
        href={(() => {
          try {
            return $props.item?.link === "/contact" ? null : $props.item?.link;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
        legacyBehavior={false}
        onClick={async event => {
          const $steps = {};

          $steps["runOnContactClick"] =
            $props.item?.link === "/contact"
              ? (() => {
                  const actionArgs = { eventRef: $props["onContactClick"] };
                  return (({ eventRef, args }) => {
                    return eventRef?.(...(args ?? []));
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
          if (
            $steps["runOnContactClick"] != null &&
            typeof $steps["runOnContactClick"] === "object" &&
            typeof $steps["runOnContactClick"].then === "function"
          ) {
            $steps["runOnContactClick"] = await $steps["runOnContactClick"];
          }
        }}
        platform={"nextjs"}
        title={(() => {
          try {
            return $props.item.name;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
      >
        <div
          data-plasmic-name={"textWrapper"}
          data-plasmic-override={overrides.textWrapper}
          className={classNames(projectcss.all, sty.textWrapper, {
            [sty.textWrapperexpanded]: hasVariant(
              $state,
              "expanded",
              "expanded"
            ),
            [sty.textWrapperwithAccordion]: hasVariant(
              $state,
              "withAccordion",
              "withAccordion"
            )
          })}
        >
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text,
              {
                [sty.textactive]: hasVariant($state, "active", "active"),
                [sty.textexpanded]: hasVariant($state, "expanded", "expanded"),
                [sty.textwithAccordion]: hasVariant(
                  $state,
                  "withAccordion",
                  "withAccordion"
                )
              }
            )}
          >
            <React.Fragment>{$props.item.name}</React.Fragment>
          </div>
        </div>
        <div
          data-plasmic-name={"icon"}
          data-plasmic-override={overrides.icon}
          aria-label={"Expand"}
          className={classNames(projectcss.all, sty.icon, {
            [sty.iconexpanded]: hasVariant($state, "expanded", "expanded"),
            [sty.iconwithAccordion]: hasVariant(
              $state,
              "withAccordion",
              "withAccordion"
            )
          })}
          onClick={async event => {
            const $steps = {};

            $steps["updateExpanded"] = true
              ? (() => {
                  const actionArgs = {
                    variable: {
                      objRoot: $state,
                      variablePath: ["expanded"]
                    },
                    operation: 0,
                    value: !$state.expanded
                  };
                  return (({ variable, value, startIndex, deleteCount }) => {
                    if (!variable) {
                      return;
                    }
                    const { objRoot, variablePath } = variable;

                    $stateSet(objRoot, variablePath, value);
                    return value;
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["updateExpanded"] != null &&
              typeof $steps["updateExpanded"] === "object" &&
              typeof $steps["updateExpanded"].then === "function"
            ) {
              $steps["updateExpanded"] = await $steps["updateExpanded"];
            }
          }}
        >
          <PlasmicImg__
            data-plasmic-name={"arrowIcon"}
            data-plasmic-override={overrides.arrowIcon}
            alt={""}
            className={classNames(sty.arrowIcon, {
              [sty.arrowIconwithAccordion]: hasVariant(
                $state,
                "withAccordion",
                "withAccordion"
              )
            })}
            displayHeight={"10px"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"6px"}
            loader={"plasmic"}
            loading={"lazy"}
            src={{
              src: "https://site-assets.plasmic.app/1391d12e512694e18d18c0be264486a8.svg",
              fullWidth: 90,
              fullHeight: 150,
              aspectRatio: 0.6
            }}
          />
        </div>
      </PlasmicLink__>
      <div
        data-plasmic-name={"submenu"}
        data-plasmic-override={overrides.submenu}
        className={classNames(projectcss.all, sty.submenu, {
          [sty.submenuexpanded]: hasVariant($state, "expanded", "expanded")
        })}
      >
        {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
          (() => {
            try {
              return $props.item.subitems;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return [];
              }
              throw e;
            }
          })()
        ).map((__plasmic_item_0, __plasmic_idx_0) => {
          const currentItem = __plasmic_item_0;
          const currentIndex = __plasmic_idx_0;
          return (
            <MobileDrawerItemSubItem
              data-plasmic-name={"mobileDrawerItemSubItem"}
              data-plasmic-override={overrides.mobileDrawerItemSubItem}
              active={(() => {
                try {
                  return window.location.pathname === currentItem.link;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return [];
                  }
                  throw e;
                }
              })()}
              className={classNames(
                "__wab_instance",
                sty.mobileDrawerItemSubItem,
                {
                  [sty.mobileDrawerItemSubItemexpanded]: hasVariant(
                    $state,
                    "expanded",
                    "expanded"
                  )
                }
              )}
              key={currentIndex}
              subitem={(() => {
                try {
                  return currentItem;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
            />
          );
        })}
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  drawerItem: [
    "drawerItem",
    "itemWrapper",
    "textWrapper",
    "text",
    "icon",
    "arrowIcon",
    "submenu",
    "mobileDrawerItemSubItem"
  ],
  itemWrapper: ["itemWrapper", "textWrapper", "text", "icon", "arrowIcon"],
  textWrapper: ["textWrapper", "text"],
  text: ["text"],
  icon: ["icon", "arrowIcon"],
  arrowIcon: ["arrowIcon"],
  submenu: ["submenu", "mobileDrawerItemSubItem"],
  mobileDrawerItemSubItem: ["mobileDrawerItemSubItem"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  drawerItem: "div";
  itemWrapper: "a";
  textWrapper: "div";
  text: "div";
  icon: "div";
  arrowIcon: typeof PlasmicImg__;
  submenu: "div";
  mobileDrawerItemSubItem: typeof MobileDrawerItemSubItem;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicMobileDrawerItem__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicMobileDrawerItem__VariantsArgs;
    args?: PlasmicMobileDrawerItem__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicMobileDrawerItem__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicMobileDrawerItem__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicMobileDrawerItem__ArgProps,
          internalVariantPropNames: PlasmicMobileDrawerItem__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicMobileDrawerItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "drawerItem") {
    func.displayName = "PlasmicMobileDrawerItem";
  } else {
    func.displayName = `PlasmicMobileDrawerItem.${nodeName}`;
  }
  return func;
}

export const PlasmicMobileDrawerItem = Object.assign(
  // Top-level PlasmicMobileDrawerItem renders the root element
  makeNodeComponent("drawerItem"),
  {
    // Helper components rendering sub-elements
    itemWrapper: makeNodeComponent("itemWrapper"),
    textWrapper: makeNodeComponent("textWrapper"),
    text: makeNodeComponent("text"),
    icon: makeNodeComponent("icon"),
    arrowIcon: makeNodeComponent("arrowIcon"),
    submenu: makeNodeComponent("submenu"),
    mobileDrawerItemSubItem: makeNodeComponent("mobileDrawerItemSubItem"),

    // Metadata about props expected for PlasmicMobileDrawerItem
    internalVariantProps: PlasmicMobileDrawerItem__VariantProps,
    internalArgProps: PlasmicMobileDrawerItem__ArgProps
  }
);

export default PlasmicMobileDrawerItem;
/* prettier-ignore-end */
